import React from "react";

import TopPostBox from "./TopPostBox";
import { authService } from "./auth";
import axios from "axios";
import mappingUtils from "./project/component/commons/utils/mappingUtils";

import PostNavbar from "./PostNavbar";
import Autosuggest from "react-autosuggest";
import Promotion from "./Promotion";

class CentralPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: authService.getUserDetailsFromLocalStorage(),
      tagRef: "TagsRef",
      suggestions: [
        { id: 3, name: "Bananas" },
        { id: 4, name: "Mangos" },
        { id: 5, name: "Lemons" },
        { id: 6, name: "Apricots" },
      ],
      promotionData: [],
    };
  }

  //display promotion data
  getPromotion = () => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/backend/public/promotion/getPromotion/" +
        this.state.userData.userId,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }).then((response) => {
      if (
        response &&
        response.data &&
        response.data.body &&
        response.status === 200
      ) {
        this.setState(
          {
            promotionData: response.data.body,
          },
          () => {
            window.$("#promotion").modal("show");
          }
        );
      }
    });
  };

  componentDidMount() {
    if(!authService.getPromotionData() || authService.getPromotionData() === false || authService.getPromotionData() === 'false'){
      this.getPromotion();
    }
  }

  autocompleteRenderInput = ({ addTag, ...props }) => {
    const handleOnChange = (e, { newValue, method }) => {
      if (method === "enter") {
        e.preventDefault();
      } else {
        props.onChange(e);
      }
    };

    const inputValue = (props.value && props.value.trim().toLowerCase()) || "";
    const inputLength = inputValue.length;

    const suggestions = this.state.suggestions.filter((state) => {
      return state.name.toLowerCase().slice(0, inputLength) === inputValue;
    });

    return (
      <Autosuggest
        ref={"TagsRef"}
        suggestions={suggestions}
        shouldRenderSuggestions={(value) => value && value.trim().length > 0}
        getSuggestionValue={(suggestion) => suggestion.name}
        renderSuggestion={(suggestion) => <span>{suggestion.name}</span>}
        inputProps={{ ...props, onChange: handleOnChange }}
        onSuggestionSelected={(e, { suggestion }) => {
          addTag(suggestion.name);
        }}
        onSuggestionsClearRequested={() => {}}
        onSuggestionsFetchRequested={() => {}}
      />
    );
  };

  closePromotionModal = (event)=>{
    event.preventDefault();
    window.$("#promotion").modal("hide");
    authService.setPromotionData(true);
  }

  setPromotionData = (event)=>{
    event.preventDefault();
    authService.setPromotionData(true);
    window.open(
        this.state.promotionData.link,"_self");
  }

  //on promotion click in window
  continueInBrowser = () => {
    localStorage.setItem("appDownloaded", true);
    this.setState({ disablebarMobileBrowser: true });
  };


  render() {
    return (
      <>
        <div className="col-md-5">
          <div className="mainpanel">
            <PostNavbar />
          </div>
        </div>
        {this.state.promotionData &&
                            this.state.promotionData.coverImageUrl
                            && this.state.promotionData.coverImageUrl &&
        <div
          id="promotion"
          className="modal fade dgpopup"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="promotionPopWrap">
                    <button type="button" className="close" data-dismiss="modal" onClick={this.closePromotionModal}
                            aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
                    <a onClick={this.setPromotionData} href={this.state.promotionData.link}><img src={
                            this.state.promotionData &&
                            this.state.promotionData.coverImageUrl
                            && this.state.promotionData.coverImageUrl
                        } alt="" /></a>

                </div>
              </div>
            </div>
          </div>
        </div>}
      </>
    );
  }
}

export default CentralPanel;
